var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade",style:({ zIndex: _vm.zIndex }),attrs:{"id":_vm.id,"tabindex":"-1","aria-hidden":"true","data-bs-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog",class:_vm.cssClass,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._t("header"),_vm._t("body"),_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }